import React from 'react';

import styles from './_MovieCardContentActionsSkeleton.module.css';

export const MovieCardContentActionsSkeleton = () => (
    <div className={styles.actions}>
        <div className={styles.mainAction} />
        <div className={styles.action} />
        <div className={styles.action} />
    </div>
);
